module.exports = __webpack_public_path__ + "static/misionero-logo-11effd92042cfa1d6f2d2d47c4b287c6.png";